import React, { useRef, useEffect } from "react";
import { motion, useInView, useAnimation } from "framer-motion";
import ShareSlider from "../sharedSlider";
import HubSpotIcon from "./icons/hubSpotIcon";
import RevenueHeroIcon from "./icons/revenueHeroIcon";
import CmoCouncilIcon from "./icons/cmoCouncilIcon";
import SemrushIcon from "./icons/semrushIcon";
const list = [
    {
        description:
            "According to RevenueHero's 2024 research, 63.5% of inbound sales inquiries never receive any response at all, letting real opportunities go cold before they're ever worked.",
        mainLogo: <RevenueHeroIcon />,
    },
    {
        description:
            "According to HubSpot, generating high-quality leads remains marketers' single biggest challenge, cited by 61% of respondents. We apply manual verification checks before any lead reaches your team, so what you receive has already been screened.",
        mainLogo: <HubSpotIcon />,
    },
    {
        description:
            "According to the CMO Council, 64% of B2B marketers say their lead generation and engagement strategy is underperforming.",
        mainLogo: <CmoCouncilIcon />,
    },
    {
        description:
            "According to Semrush, businesses using AI-assisted content marketing report a 68% increase in content marketing ROI. Our own programs lean on content-rich, SEO-optimized pages built to attract and nurture prospects at scale.",
        mainLogo: <SemrushIcon />,
    },
];
export default function WhyOutsource() {
    const mainSectionDevRef = useRef(null);
    const isInView = useInView(mainSectionDevRef, { once: true });
    const firstEl = useAnimation();

    useEffect(() => {
        if (isInView) {
            firstEl.start("visible").catch(() => {});
        }
    }, [isInView]);
    return (
        <motion.section
            ref={mainSectionDevRef}
            className="flex flex-col  lg:flex-row items-center  gap-5 lg:mt-60 mt-36 overflow-hidden  py-4"
            variants={{
                visible: {
                    y: [150, 0],
                    transition: { duration: 1.5 },
                },
            }}
            animate={firstEl}
        >
            <div className="3xl:max-w-[600px]  lg:max-w-[410px] z-10 ">
                <h2 className="font-bold 3xl:text-7xl 3xl:leading-[5rem] lg:text-5xl text-3xl lg:leading-[54px] leading-9  text-center lg:text-left">
                    The Science of Lead Generation
                </h2>
            </div>
            <div className="sm:flex z-10  items-center justify-center w-full     ">
                <ShareSlider deferentStyle={true} list={list} perPage={2} />
            </div>
        </motion.section>
    );
}
